import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import closeImg from '../../Images/close.svg';
import cellcomLogo from '../../Images/cellcomLogo.svg';
import './PhoneStage.scss';
import TextInput from 'app/Components/Shared/TextInput/TextInput';
import FuntoneButton from '../../../../Components/FuntoneButton/FuntoneButton';
export default function PhoneStageUI({
  phoneLabel = 'מה מספר הטלפון שלך?',
  title = 'זיהוי מהיר והשיר אצלך',
  phone = '',
  onPhoneChange,
  onSubmit,
  loading = false,
  error = ' ',
}) {
  return (
    <form className='phone-stage-wrapper' onSubmit={onSubmit}>
      <div className='top-content'>
        <div className='logo-container'>
          <Image src={cellcomLogo} className='logo' alt='logo' />
        </div>
        <span className='title'>{title}</span>
        <TextInput
          className='input'
          name={'login-phone-input'}
          type='number'
          pattern='[0-9]*'
          id={'login-phone-input'}
          maxLength='10'
          autoComplete='off'
          placeholder={phoneLabel}
          value={phone}
          error={error}
          onChange={(e) => onPhoneChange && onPhoneChange(e.target.value)}
          disabled={loading}
        />
      </div>
      <FuntoneButton text={loading ? 'טוען...' : 'בואו נתקדם'} variant='primary' type='submit' disabled={loading} />
    </form>
  );
}
